// Small helpers for the Profile page.

// "google" | "password" | "legacy" (old username accounts that never used Firebase) | ""
export function signInMethodOf(firebaseUser) {
  if (!firebaseUser) return "legacy";
  const ids = (firebaseUser.providerData || []).map((p) => p.providerId);
  if (ids.includes("password")) return "password";
  if (ids.includes("google.com")) return "google";
  return "";
}

export function signInLabel(method) {
  if (method === "google") return "Signed in with Google";
  if (method === "password") return "Signed in with email";
  return "";
}

// "October 2026" from a date string; null when it is missing or not a date.
export function memberSinceLabel(dateString) {
  if (!dateString) return null;
  const d = new Date(dateString);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString("en-US", { month: "long", year: "numeric" });
}
